import React from "react"
import { Link } from "gatsby"
import { css } from "@emotion/core"
import t from "theme"
import linkResolver from "utils/linkResolver"

const CompanyWithIcon = ({ company, size = t.font.size[2], ...props }) => (
    <Link to={linkResolver({ type: "OVERVIEW", ticker: company.ticker })}>
        <div
            css={css`
                display: flex;
                align-items: center;
                font-weight: ${t.font.weight.semibold};
                :hover {
                    color: ${t.color.primary};
                    transform: translateY(-3px);
                    transition: transform 0.2s ease-in-out;
                }
                :active {
                    transform: translateY(-1px);
                    transition: transform 0.1s ease-in-out;
                }
            `}
            {...props}>
            <span
                className={"icon-logo-" + company.ticker.toLowerCase()}
                css={css`
                    font-size: calc(${size} * 1.8);
                    margin-right: calc(${size} * 0.7);
                    vertical-align: middle;
                `}
            />

            <span
                css={css`
                    text-transform: uppercase;
                    font-size: ${size};
                    letter-spacing: calc(${size} * 0.05);
                `}>
                {company.shortName}
            </span>
        </div>
    </Link>
)

export default CompanyWithIcon
